import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
export interface SelectItem {
  label: string;
  backgroundColor?: string;
  labelColor?: string;
}

const selectAllValue = 'select-all';

@Component({
  selector: 'kt-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnChanges {
  @Input() heading: string;
  @Input() placeholder: string = 'All Statuses';
  @Input() allowSelectAll: boolean = false;
  @Input() items: SelectItem[] = [];
  @Input() selectedValues: SelectItem[] = [];
  @Output() selectedItems = new EventEmitter<SelectItem>();
  form: UntypedFormGroup;
  selectedText: string = '';
  selectAllValue = selectAllValue;

  constructor() {
    // Setup form
    this.form = new UntypedFormGroup({
      item: new UntypedFormControl([])
    });
  }

  ngOnChanges(changes) {
    if (changes.selectedValues && changes.selectedValues.previousValue != changes.selectedValues.currentValue) {
      let isAllItemsSelected = this.items.length > 0 && this.selectedValues.length === this.items.length && this.items.every(item => this.selectedValues.includes(item));
      if (isAllItemsSelected) {
        let selectedItems = [selectAllValue, ...this.selectedValues]
        this.form.get('item').setValue(selectedItems);
      } else {
        this.form.get('item').setValue(this.selectedValues);
      }
      this.selectedText = this.getSelectedText();
    }
  }

  isAllSelected(): boolean {
    let selectedValues = this.form.get('item')?.value || [];
    selectedValues = selectedValues.filter(value => value !== selectAllValue);
    return selectedValues.length === this.items.length;
  }

  toggleAllSelection() {
    let selectedValues = this.form.get('item')?.value || [];
    // Remove 'select-all' if present
    selectedValues = selectedValues.filter(value => value !== selectAllValue);

    if (selectedValues.length === this.items.length) {
      // If everything is already selected, clear all
      this.form.get('item')?.setValue([]);
    } else {
      // Otherwise select everything
      this.form.get('item')?.setValue([selectAllValue, ...this.items]);
    }
    this.emitSelections();
  }

  emitSelections() {
    let selectedValues = this.form.get('item')?.value || [];
    // Remove 'select-all' if present
    selectedValues = selectedValues.filter(value => value !== selectAllValue);
    this.selectedItems.emit(selectedValues);
    this.selectedText = this.getSelectedText();
  }

  getSelectedText() {
    return (this.form.get('item')?.value || [])
      .filter(value => value !== selectAllValue)
      .map(value => value.label)
      .join(', ')
  }

}
